export default (branch) => ({
  loading: false,
  chartData: null,
  branch,
});
